import React from 'react'
import fileDownload from 'js-file-download'
import { useSelector, useDispatch } from 'react-redux'
import { CloudDownload } from '@material-ui/icons'
import { Tooltip, Button } from '@material-ui/core'

import { useStyles } from './styles'
import { createQueryForExport } from '../../../utils/productionPanel'
import { getExportRequest } from '../../../api/controlPanel'
import { getTodayDate } from '../../../utils/dates'
import { setHandleAlert } from '../../../store/actions/common'

const ExportToExcel = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const userData = useSelector(({ multitenantUser }) => ({
    accessToken: multitenantUser.accessToken,
    tenantId: multitenantUser.tenants?.find((t) => t.selected)?.id || 0,
  }))
  const exportQuery = useSelector((state) => state.controlPanel.exportQuery)

  const getExportFile = () => {
    const localDate = getTodayDate('YYYY-MM-DD')
    const query = createQueryForExport(exportQuery, localDate)

    getExportRequest(userData.accessToken, userData.tenantId, query)
      .then((res) => {
        showAlertMessage('Download successful', true, 'success')
        const fileName = res?.headers['content-disposition']
          ?.split(';')[1]
          ?.split('=')[1]
          ?.replaceAll('"', '')

        fileDownload(res.data, fileName)
      })
      .catch((error) => {
        showAlertMessage('Something wrong happened', true, 'error')
      })
  }

  const showAlertMessage = (message, status, severity) => {
    dispatch(
      setHandleAlert({
        message,
        status,
        severity,
      })
    )
  }

  const handleClick = () => {
    showAlertMessage('Downloading .CSV file', true, 'success')
    getExportFile()
  }

  return (
    <Tooltip title="Export the last filter search to CSV" placement="bottom">
      <Button
        size="small"
        className={classes.exportButton}
        variant="outlined"
        onClick={handleClick}
        startIcon={<CloudDownload />}
        id={`exportExcelButton`}
      >
        Export
      </Button>
    </Tooltip>
  )
}

export default ExportToExcel
